{
  "name": "@okrapdf/sdk",
  "version": "0.17.0",
  "okraApi": "^1.14.0",
  "description": "okraPDF — upload a PDF, get an API. Runtime client, React hooks, and CLI.",
  "type": "module",
  "exports": {
    ".": {
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      }
    },
    "./doc": {
      "import": {
        "types": "./dist/url.d.ts",
        "default": "./dist/url.js"
      }
    },
    "./browser": {
      "import": {
        "types": "./dist/browser.d.ts",
        "default": "./dist/browser.js"
      }
    },
    "./worker": {
      "import": {
        "types": "./dist/worker.d.ts",
        "default": "./dist/worker.js"
      }
    },
    "./server": {
      "import": {
        "types": "./dist/server/index.d.ts",
        "default": "./dist/server/index.js"
      }
    },
    "./react": {
      "import": {
        "types": "./dist/react/index.d.ts",
        "default": "./dist/react/index.js"
      }
    },
    "./cli": {
      "import": {
        "types": "./dist/cli/index.d.ts",
        "default": "./dist/cli/index.js"
      }
    },
    "./content-types": {
      "import": {
        "types": "./dist/content-types/index.d.ts",
        "default": "./dist/content-types/index.js"
      }
    }
  },
  "files": [
    "dist",
    "skills"
  ],
  "scripts": {
    "build": "tsup",
    "prepublishOnly": "pnpm run build",
    "docs:cli": "node ./scripts/generate-cli-docs.mjs && node ./scripts/generate-cli-reference.mjs",
    "docs:cli:check": "node ./scripts/generate-cli-docs.mjs --check && node ./scripts/generate-cli-reference.mjs --check",
    "docs:cli:reference": "node ./scripts/generate-cli-reference.mjs",
    "docs:cli:reference:check": "node ./scripts/generate-cli-reference.mjs --check",
    "test": "vitest run --exclude '**/**.e2e.test.ts'",
    "test:e2e": "vitest run src/client.e2e.test.ts",
    "test:watch": "vitest",
    "typecheck": "tsc --noEmit"
  },
  "dependencies": {
    "@okrapdf/component": "0.1.0",
    "@effect/platform-node": "4.0.0-beta.107",
    "@effect/platform-node-shared": "4.0.0-beta.107",
    "@hono/node-server": "^2.0.5",
    "commander": "^12.0.0",
    "effect": "4.0.0-beta.107",
    "hono": "^4.12.26",
    "html-rewriter-wasm": "^0.4.1",
    "ws": "^8.19.0",
    "zod": "^4.3.6"
  },
  "peerDependencies": {
    "agents": "^0.12.0",
    "pg": "^8.13.0",
    "react": ">=18"
  },
  "peerDependenciesMeta": {
    "agents": {
      "optional": true
    },
    "pg": {
      "optional": true
    },
    "react": {
      "optional": true
    }
  },
  "devDependencies": {
    "@okrapdf/core": "workspace:*",
    "@okrapdf/ecosystem-catalog": "workspace:*",
    "@okrapdf/parser-sdk": "workspace:*",
    "@okrapdf/parser-unstructured": "workspace:*",
    "@okrapdf/protocol": "workspace:*",
    "@okrapdf/schemas": "workspace:*",
    "@types/node": "^20.14.0",
    "@types/pg": "^8.11.0",
    "@types/react": "^18.2.0",
    "@types/react-dom": "^18.2.0",
    "@types/ws": "^8.18.1",
    "agents": "^0.12.0",
    "jsdom": "27.4.0",
    "pg": "^8.13.0",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "tsup": "^8.0.0",
    "typescript": "^5.5.0",
    "vitest": "^2.0.0"
  },
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/steventsao/okra.git",
    "directory": "packages/okrapdf"
  },
  "homepage": "https://okrapdf.com",
  "author": "okraPDF",
  "keywords": [
    "pdf",
    "ocr",
    "document",
    "extraction",
    "api",
    "sdk",
    "structured-output"
  ],
  "publishConfig": {
    "access": "public"
  }
}
